/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { getOnDemandRequest } from 'redux/reducers/onDemand';
import actions from 'redux/actions';
import ScrollableContent from 'components/ScrollableContent';
import ActionButton from 'components/ActionButton';
import OnDemandRequestsForm, { requestTypes } from 'forms/OnDemandRequestsForm';
import styles from './styles.module.scss';

import type {
  ReduxState,
  ReactRouterProps,
  Translate,
  OnDemand,
  Track,
  MergedLicenseComponent,
  WorklistItem,
  Smartlist,
} from 'types';

type State = {};

const mapStateToProps = (state: ReduxState) => {
  return {
    onDemandRequest: getOnDemandRequest(state),
  };
};

type Props = ReactRouterProps & {
  submitOnDemandRequest: typeof actions.submitOnDemandRequest,
  onDemandRequest:
    | { type: 'QUOTATION', data: WorklistItem[] }
    | { type: 'TRACKS', data: Track[] }
    | { type: 'SMARTLIST', data: Smartlist },
  displayMessage: typeof actions.displayMessage,
  t: Translate,
};

class OnDemandRequests extends React.Component<Props, State> {
  _handleSubmit = async (request: OnDemand) => {
    await this.props.submitOnDemandRequest(request);
    this.props.history.goBack();
  };

  _getPerformersFromTrack = (track: Track): string => {
    return (track.performers || []).reduce(
      (acc, performer) => `${acc && `${acc}, `}${performer.fullName}`,
      ''
    );
  };

  _getAuthorsFromTrack = (track: Track): string => {
    return (track.authors || []).reduce(
      (acc, author) => `${acc && `${acc}, `}${author.fullName}`,
      ''
    );
  };

  _getTitleFromTrack = (track: Track): string => {
    const performers = this._getPerformersFromTrack(track);
    return `${performers} - ${track.title}`;
  };

  _getTitleFromTracks = (tracks: Track[]): string => {
    return tracks.reduce(
      (acc, track) => `${acc && `${acc}\n`}${this._getTitleFromTrack(track)}`,
      ''
    );
  };

  _getTitleFromComponent = (mergedComponent: MergedLicenseComponent) => {
    return `${mergedComponent.description}`;
  };

  _getTitleFromComponents = (mergedComponents: MergedLicenseComponent[]) => {
    return mergedComponents.reduce(
      (acc, component) => `${acc && `${acc}, `}${this._getTitleFromComponent(component)}`,
      ''
    );
  };

  render() {
    const { onDemandRequest } = this.props;
    let initialValues = {
      id: 0,
      date: Date.now(),
      requestType: 0,
    };
    if (onDemandRequest) {
      switch (onDemandRequest.type) {
        case 'TRACKS': {
          initialValues = {
            ...initialValues,
            requestType: requestTypes.track,
          };
          if (Array.isArray(onDemandRequest.data)) {
            const tracks: Track[] = onDemandRequest.data;
            if (tracks.length > 0) {
              const track = tracks[0];
              initialValues = {
                ...initialValues,
                trackTitle: track.title,
                trackPerformers: this._getPerformersFromTrack(track),
                trackAuthors: this._getAuthorsFromTrack(track),
              };
            }
          }
          break;
        }
        case 'QUOTATION': {
          initialValues = {
            ...initialValues,
            requestType: requestTypes.quotation,
          };
          if (Array.isArray(onDemandRequest.data)) {
            const worklistItems: WorklistItem[] = onDemandRequest.data;
            // const tracks = worklistItems.filter(item => item.track != null).map(item => item.track);
            // const quotationTitle = this._getTitleFromTracks(tracks);

            const quotationTitle = worklistItems.reduce(
              (acc, worklistItem) =>
                `${acc && `${acc}, `}${this._getTitleFromTrack(worklistItem.track)} (${
                  worklistItem.components
                    ? this._getTitleFromComponents(worklistItem.components)
                    : '?'
                })`,
              ''
            );
            initialValues = {
              ...initialValues,
              quotationTitle,
              worklistItems,
            };
          }
          break;
        }
        case 'SMARTLIST': {
          initialValues = {
            ...initialValues,
            requestType: requestTypes.smartlist,
          };
          break;
        }
        default: {
        }
      }
    }
    return (
      <div className={styles.root}>
        <ScrollableContent>
          <div className={styles.content}>
            <div className={styles.actionButtons}>
              <ActionButton iconName={'close'} onClick={this.props.history.goBack} />
            </div>
            <OnDemandRequestsForm initialValues={initialValues} onSubmit={this._handleSubmit} />
          </div>
        </ScrollableContent>
      </div>
    );
  }
}

export default withTranslation()(
  withRouter(
    connect(
      mapStateToProps,
      actions
    )(OnDemandRequests)
  )
);
